export function appendToParams(url, getParamsToUpdate) {
  if (typeof getParamsToUpdate !== "object") return false;

  // remove consecutive duplicate '&' chars from the url
  url = url.replace(/(&)\1+/g, '&')
  //Note: substr(1) removes first character (getting rid of possible "?")
  //			(does nothing with empty string)
  let getParams = url.substr(1).split('&');

  //avoid extra "&" at the beginning if current document.location.search was empty or 1 char
  if ((getParams.length < 1) || ((getParams.length === 1) && (getParams[0] === "")))
    getParams = [];

  let searchBuffer;
  let found;

  for (let k in getParamsToUpdate) {
    if (!getParamsToUpdate.hasOwnProperty(k)) continue;

    let key = encodeURIComponent(k);
    let value = encodeURIComponent(getParamsToUpdate[k]);

    searchBuffer = [];
    found = false;

    let paramsLength = getParams.length - 1
    //from the end to start...
    for (let i = paramsLength; i >= 0; --i) {
      searchBuffer = getParams[i].split('=');

      if (searchBuffer[0] === key) {
        //found key!
        getParams[i] = key + '=' + value;
        found = true;
        break;
      }
    }

    if (!found) getParams.push(key + '=' + value);
  }

  return getParams.join('&');
}